export default "/images/banner-expertplatform.jpg";